import fetch from 'auth/FetchInterceptor'

const rastreadorService = {}

rastreadorService.all = function () {
  return fetch({
    url: '/rastreador/all',
    method: 'get',
    headers: {
        'Content-Type': 'application/json',
      },
  })
}

rastreadorService.paginated = function ({ page = 0, size = 10, imei = '', numero = '' } = {}) {
  return fetch({
    url: '/rastreador',
    method: 'get',
    params: { page, size, imei, numero },
  })
}

rastreadorService.disponivel = function () {
  return fetch({
    url: '/rastreador/disponivel',
    method: 'get',
    headers: {
        'Content-Type': 'application/json',
      },
  })
}

rastreadorService.save = function (data) {
  return fetch({
    url: '/rastreador',
    method: 'post',
    data: data
  })
}

rastreadorService.id = function (data) {
  return fetch({
    url: `/rastreador/${data}/id`,
    method: 'get',
    data: data
  })
}

rastreadorService.inativar = function (data) {
  return fetch({
    url: `/rastreador/${data}/inativar`,
    method: 'put',
    data: data
  })
}

rastreadorService.ativar = function (data) {
  return fetch({
    url: `/rastreador/${data}/ativar`,
    method: 'put',
    data: data
  })
}

rastreadorService.enviarSms = function (data) {
  return fetch({
    url: `/rastreador/${data}/sms`,
    method: 'put',
    data: data
  })
}

rastreadorService.enviarSmsManual = function (data) {
  return fetch({
    url: `/rastreador/sms`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: data
  })
}

rastreadorService.enviarSmsEconomico = function (data) {
  return fetch({
    url: `/rastreador/${data}/economico`,
    method: 'put',
    data: data
  })
}

rastreadorService.enviarSmsNormal = function (data) {
  return fetch({
    url: `/rastreador/${data}/normal`,
    method: 'put',
    data: data
  })
}

rastreadorService.exportarCSV = function () {
  return fetch({
    url: '/rastreador/exportar-csv',
    method: 'get',
    responseType: 'blob',
  })
}

export default rastreadorService